module.exports = __webpack_public_path__ + "2e7c6c6f35ee42fbd1264b169410c9bb.woff2";